/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Node } from '@msdyn365-commerce-modules/utilities';
import React, { ReactNode } from 'react';

import { ITileListViewProps } from './moe-tile-list-medium-image';

/**
 * View component.
 * @param props - The view properties.
 * @returns Returns props.
 */
export const tileListView: React.FC<ITileListViewProps> = props => {
    const { title, tiles, tileListContainer, tileListHeading, tileItemContainer, singleSlideCarouselComponentProps } = props;

    const fetchTitleTypeClass = (): any => {
        if (props.config.tileType === 'normal') {
            return '';
        } else if (props.config.tileType === 'decorative') {
            return 'moe-decorator-tile--mdm';
        }
    };

    return (
        <div tabIndex={0} className={`tile-lists-medium-img-main-container container ${fetchTitleTypeClass()}`}>
            <Node {...tileListContainer}>
                <Node {...tileListHeading}>{title}</Node>
                <Node {...singleSlideCarouselComponentProps}>
                    {tiles.map((tileItem: ReactNode, index: number) => {
                        const keyIndex = `tile-list-item__${index}`;
                        return (
                            <Node {...tileItemContainer} key={keyIndex}>
                                {tileItem}
                            </Node>
                        );
                    })}
                </Node>
            </Node>
        </div>
    );
};

export default tileListView;
